const webConfig = {
  sitePrefix: '/msa'
}

export default webConfig
